<template>
	<div class="leasing-calculator">
		<div v-if="desktop">
			<button-icon-group
				:items="button_label"
				:active="type_leasing"
				:change="change_type_leasing"
				:def="type_leasing"
			></button-icon-group>
		</div>
		<div v-else class="leasing-calculator__range">
			<label>Выберите предмет лизинга</label>
			<form method="post" class="leasing-calculator__select-wrap">
				<select v-model="type_leasing" class="leasing-calculator__select" name="leasing-calculator" id="calculator">
					<option v-for="item in button_label" :key="item.value" selected :value="item.value">{{ item.name }}</option>
				</select>
				<div class="leasing-calculator__select-arrow">
					<img src="../../../images/icon/leasing-calculator__select-vector.svg" />
				</div>
			</form>
		</div>
		<div>
			<div class="leasing-calculator__range">
				<label>Стоимость предмета лизинга</label>
				<range-slider
					class="slider"
					v-model="range_one.value"
					:name="range_one.name"
					:min="range_one.min"
					:max="range_one.max"
					:step="range_one.step"
					:disabled="range_one.disabled"
					:valueFormat="range_one.valueFormat"
				></range-slider>
				<ul class="leasing-calculator__currency">
					<li
						v-for="item in currency"
						:key="item.id"
						@click="setCurrency(item)"
						v-bind:class="[
							'leasing-calculator__currency_item',
							`leasing-calculator__currency_item--${item}`,
							item === currency_active ? 'active' : ''
						]"
					></li>
				</ul>
			</div>
			<div class="leasing-calculator__range">
				<label for>Срок лизинга</label>
				<range-slider
					class="slider"
					v-model="range_two.value"
					:name="range_two.name"
					:min="range_two.min"
					:max="range_two.max"
					:step="range_two.step"
					:disabled="range_two.disabled"
					:valueFormat="range_two.valueFormat"
				></range-slider>
			</div>
			<div class="leasing-calculator__range">
				<label for>Величина аванса</label>
				<range-slider
					class="slider"
					v-model="range_three.value"
					:name="range_three.name"
					:min="range_three.min"
					:max="range_three.max"
					:step="range_three.step"
					:disabled="range_three.disabled"
					:valueFormat="range_three.valueFormat"
				></range-slider>
			</div>
			<div>
				<button class="btn btn--primary" @click.prevent="openModal">Получить расчет</button>
			</div>
			<div class="leasing-calculator__images">
				<img v-bind:src="leasingCalculator__images[type_leasing]" />
			</div>
		</div>
		<template>
			<v-modal ref="modal" title="ПОЛУЧИТЬ РАСЧЕТ">
				<form @submit.prevent="send">
					<div class="form-group">
						<label class="form-label">Ваше имя (обязательно)</label>
						<input class="form-control" v-model="name" />
						<div class="form-control-feedback"></div>
					</div>
					<div class="form-group">
						<label class="form-label">Телефон (обязательно)</label>
						<imask-input class="form-control" mask="+{7} (000) 00 00 000" v-model="phone" />
						<div class="form-control-feedback"></div>
					</div>
					<div class="form-group">
						<label class="form-label">ИНН</label>
						<input class="form-control" v-model="inn" />
						<div class="form-control-feedback"></div>
					</div>
					<div class="form-group">
						<div class="custom-checkbox">
							<input type="checkbox" v-model="agree" />
							<span>Я согласен на обработку персональных данных</span>
						</div>
					</div>
					<div class="form-group">
						<button class="btn btn--primary" :disabled="!agree || disabled">ОТПРАВИТЬ ЗАЯВКУ</button>
					</div>
				</form>
			</v-modal>
		</template>
	</div>
</template>
<script>
import RangeSlider from './RangeSlider.vue';
import ButtonIconGroup from './ButtonIconGroup.vue';
import { decOfNum, randomInteger } from '~libs/util';

import Modal from '../Modal/index.vue';
import Axios from 'axios';
import { IMaskComponent } from 'vue-imask';
import swal from 'sweetalert';

export default {
	data() {
		return {
			type_leasing: 'Автотранспорт и спецтехника',
			desktop: true,
			currency: ['ruble', 'euro', 'dollar'],
			currency_active: 'euro',
			range_one: {
				value: 200000,
				min: 200000,
				max: 200 * 1000 * 1000,
				step: 1000,
				disabled: false,
				valueFormat: function (value) {
					let currency = {
						ruble: '₽',
						euro: '€',
						dollar: '$'
					};

					let format = window.Intl
						? new Intl.NumberFormat('ru-RU').format(this.$parent.range_one.arr[value])
						: this.$parent.range_one.arr[value];
					let text = format + ' ' + currency[this.$parent.currency_active];
					return text;
				}
			},
			range_two: {
				value: 1 * 12,
				min: 1 * 12,
				max: 12 * 10,
				step: 1,
				disabled: false,
				valueFormat: function () {
					// return  new Intl.NumberFormat('ru-RU').format(this.actualValue) + ` ₽`
					let yers = Math.floor(this.actualValue / 12);
					let mount = Math.floor(this.actualValue % 12);
					let text = ``;
					console.log(yers, mount);

					if (yers > 0) {
						text += yers + ' ' + decOfNum(yers, ['год', 'года', 'лет']) + ' ';
					}

					if (mount > 0) {
						text += mount + ' ' + decOfNum(mount, ['месяц', 'месяца', 'месяцев']);
					}
					return text;
				}
			},
			range_three: {
				value: 10,
				min: 10,
				max: 49,
				step: 1,
				disabled: false,
				valueFormat: function (value) {
					return (window.Intl ? new Intl.NumberFormat('ru-RU').format(value) : value) + `%`;
				}
			},
			agree: false,
			name: '',
			phone: '',
			inn: '',
			disabled: false,
			leasingCalculator__images: {
				// 'Автотранспорт и спецтехника': THEME.url + '/images/spetztech.png',
				// Оборудование: THEME.url + '/images/oborud.png',
				// 'Оперативный лизинг': THEME.url + '/images/operat_liz.png',
				// 'Финансирование импорта': THEME.url + '/images/fin_import.png',
				// 'Лизинг недвижимости': THEME.url + '/images/nedvizh_liz.png'
			},
			button_label: [
				{
					value: 'Автотранспорт и спецтехника',
					name: 'Автотранспорт и спецтехника',
					icon: [
						// THEME.url + '/images/FormPR_black_01.svg',
						// THEME.url + '/images/FormPR_white_01.svg'
					]
				},
				{
					value: 'Оборудование',
					name: 'Оборудование',
					icon: [
						// THEME.url + '/images/FormPR_black_02.svg',
						// THEME.url + '/images/FormPR_white_02.svg'
					]
				},
				{
					value: 'Оперативный лизинг',
					name: 'Оперативный лизинг',
					icon: [
						// THEME.url + '/images/FormPR_black_03.svg',
						// THEME.url + '/images/FormPR_white_03.svg'
					]
				},
				{
					value: 'Финансирование импорта',
					name: 'Финансирование импорта',
					icon: [
						// THEME.url + '/images/FormPR_black_04.svg',
						// THEME.url + '/images/FormPR_white_04.svg'
					]
				},
				{
					value: 'Лизинг недвижимости',
					name: 'Лизинг недвижимости',
					icon: [
						// THEME.url + '/images/FormPR_black_05.svg',
						// THEME.url + '/images/FormPR_white_05.svg'
					]
				}
			]
			// range
		};
	},
	created() {
		this.currency_active = this.currency[Math.floor(Math.random() * this.currency.length)];
		let arr = [];
		let step = 10000;
		let index = 200000;
		while (index <= 200 * 1000 * 1000) {
			arr.push(index);
			// if (index >= 5000000) {
			//     step = 10000000
			// }
			if (index === 100000) {
				step *= 10;
			}
			// if (index === 1000000) {
			// 	step *= 10;
			// }
			// if (index === 10000000) {
			// 	step *= 10;
			// }
			index += step;
		}
		this.range_one.min = 0;
		this.range_one.max = arr.length - 1;
		this.range_one.step = 1;
		this.range_one.arr = arr;

		this.range_one.value = randomInteger(0, arr.length);
		this.range_two.value = randomInteger(this.range_two.min, this.range_two.max);
		this.range_three.value = randomInteger(this.range_three.min, this.range_three.max);

		// this.type_leasing =this.button_label[Math.floor(Math.random() * this.button_label.length)].value;
	},
	mounted() {
		const leasingCalculator = document.querySelector('.leasing-calculator');
		const mediaQuery = window.matchMedia('(max-width: 768px)');
		// Если разрешение экрана меньше 768 пикселей
		if (mediaQuery.matches) {
			this.desktop = false;
		}
	},
	methods: {
		change_type_leasing(active) {
			this.type_leasing = active;
		},
		setCurrency(e) {
			this.currency_active = e;
		},
		openModal() {
			this.$refs['modal'].modalOpen();
		},

		showError(error) {
			swal('Ошибка', error, 'error');
		},
		async send(event) {
			try {
				const { type_leasing, prepaid, term, cost } = this;
				const { name, phone, agree } = this;
				this.disabled = true;
				const { data } = await Axios.post(
					'/forms/leasing-calculator',
					{ name, phone, agree, type_leasing, prepaid, term, cost },
					{
						validateStatus(status) {
							return [200, 201, 403].includes(status);
						},
						headers: {
							'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
						}
					}
				);
				if (data.response === 'errors') {
					this.showError(data.errors[0]);
				} else if (data.response === 'ok') {
					swal('Отправлено', 'Спасибо за заявку');
					this.$refs['modal'].modalClose();
				}
			} catch (error) {
				this.showError(error.message);
			}
			this.disabled = false;
		}
	},
	computed: {
		_total_payment() {
			let sum = 1;
			for (let i = 0; i < this.range_two.value; i++) {
				sum *= 1 + 0.134;
			}
			sum = sum * this.range_one.value;
			sum = Math.round(sum);
			return sum;
			// return  new Intl.NumberFormat('ru-RU').format(sum) + ` ₽`
		},
		monthly_payment() {
			return new Intl.NumberFormat('ru-RU').format(Math.round(this._total_payment / this.range_two.value)) + ` ₽`;
		},

		total_payment() {
			return new Intl.NumberFormat('ru-RU').format(this._total_payment) + ` ₽`;
		},

		prepaid() {
			return (
				(window.Intl ? new Intl.NumberFormat('ru-RU').format(this.range_three.value) : this.range_three.value) + `%`
			);
		},
		term() {
			let yers = Math.round(this.range_two.value / 12);
			let mount = Math.round(this.range_two.value % 12);
			let text = ``;

			if (yers > 0) {
				text += yers + ' ' + decOfNum(yers, ['год', 'года', 'лет']) + ' ';
			}

			if (mount > 0) {
				text += mount + ' ' + decOfNum(mount, ['месяц', 'месяца', 'месяцев']);
			}
			return text;
		},
		cost() {
			let currency = {
				ruble: '₽',
				euro: '€',
				dollar: '$'
			};

			let format = window.Intl
				? new Intl.NumberFormat('ru-RU').format(this.range_one.arr[this.range_one.value])
				: this.range_one.arr[this.range_one.value];
			let text = format + ' ' + currency[this.currency_active];

			return text;
		}
	},
	updated: function () {},

	components: {
		'range-slider': RangeSlider,
		'button-icon-group': ButtonIconGroup,
		'v-modal': Modal,
		'imask-input': IMaskComponent
	}
};

// import ff from ''
</script>
<style lang="scss">
@import '~style/utils/_vars';
@import '~style/utils/_mixins';

$slider-height: 0px !default;
$slider-width: 100% !default;
$rail-height: 10px !default;
$knob-size: 15px !default;
$rail-color: #e2e2e2 !default;
$rail-fill-color: $brand-color !default;
$knob-color: #fff !default;
$knob-border: 1px solid #f5f5f5 !default;
$knob-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2) !default;
.range-slider {
	display: block;
	padding: 0 0;
	//   height: $slider-height;
	width: $slider-width;
	margin: 20px 0px;
	background: #f9f9f9;
	border: 1px solid $brand-color;
	padding: 9px 15px;
	position: relative;
}
.range-slider.disabled {
	opacity: 0.5;
}
.range-slider-inner {
	display: block;
	position: relative;
	height: 0;
	width: 100%;
	position: absolute;
	bottom: 0;
	left: 0;
}
.range-slider-rail,
.range-slider-fill {
	display: block;
	position: absolute;
	top: 50%;
	left: 0;
	height: 0;
	// border-radius: $rail-height / 2;
	transform: translateY(-50%);
}
.range-slider-rail {
	width: 100%;
	background-color: $rail-color;
}
.range-slider-fill {
	background-color: $rail-fill-color;
}
.range-slider-knob {
	display: block;
	position: absolute;
	top: 0%;
	left: 0;
	box-sizing: border-box;
	height: $knob-size;
	width: $knob-size;
	// border: $knob-border;
	// border-radius: 50%;
	background-color: $brand-color;
	border: none;
	// box-shadow: $knob-shadow;
	transform: translate(-50%, 0%);
	cursor: pointer;
	&:hover,
	&:active {
		// box-shadow: 1px 3px 10px rgba(0, 0, 0, 0.25);
	}
	&::after {
		content: '';
		position: absolute; /* Абсолютное позиционирование */
		top: -15px;
		border: 7.5px solid transparent; /* Прозрачные границы */
		border-bottom: 7.5px solid $brand-color; /* Добавляем треугольник */
	}
}
.range-slider-hidden {
	display: none;
}

.range-slider-label {
	font-size: 18px;
	line-height: 22px;
	color: #000000;
	// margin-bottom: 5px;
	display: flex;
	justify-content: space-between;
}
.range-slider-value {
	text-align: left;
	flex: 1;
}

.button-icon-group {
	&__item {
		// background:$brand-color;
		font-size: 22px;
		line-height: 130%;
		/* or 29px */

		color: #000000;
		// height: 70px;
		width: 100%;
		display: flex;
		// padding: 10px 30px;
		align-items: center;
		cursor: pointer;
		margin: 0px;
		input[type='radio'],
		input[type='checkbox'] {
			position: absolute;
			clip: rect(0, 0, 0, 0);
			pointer-events: none;
		}

		overflow: hidden;
		&.active {
			// background: darken($color: $brand-color, $amount: 0);
			// color: #ffffff;
			// &:hover {
			// 	background: darken($color: $brand-color, $amount: 0);
			// }
		}
		// &:hover {
		// 	background: darken($color: #fff, $amount: 5);
		// }
	}
	&__icon {
		width: 81px;
		height: 81px;
		flex: 0 0 81px;
		margin-right: 0px;
		// background-image: url('./../../../images/icon/round-outline-icon.svg');
		// background-repeat-: no-repeat;
		// background-size: auto 81px;
		position: relative;

		&::after {
			width: 65px;
			height: 65px;
			content: '';
			display: block;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
	}
}

.leasing-calculator {
	background: #e6e9ef;
	position: relative;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	& > div {
		padding: 55px 40px;
		@media (max-width: 768px) {
			padding: 55px 20px 5px;
			padding-top: 15px;
		}
	}

	.button-icon-group {
		.button-icon-group__item {
			.button-icon-group__icon {
				border-radius: 50%;
				margin-right: 28px;
				// mt
			}
			&[data-index='Автотранспорт и спецтехника'] {
				.button-icon-group__icon {
					&::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 30);
					}
				}
				&.active {
					.button-icon-group__icon::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 31);
					}
				}
			}
			&[data-index='Оборудование'] {
				.button-icon-group__icon {
					&::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 32);
					}
					// background-position-x: #{(81 * 0)}px;
				}
				&.active {
					.button-icon-group__icon::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 33);
					}
				}
			}
			&[data-index='Оперативный лизинг'] {
				.button-icon-group__icon {
					&::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 34);
					}
					// background-position-x: #{(81 * 0)}px;
				}
				&.active {
					.button-icon-group__icon::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 35);
					}
				}
			}
			&[data-index='Финансирование импорта'] {
				.button-icon-group__icon {
					&::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 36);
					}
					// background-position-x: #{(81 * 0)}px;
				}
				&.active {
					.button-icon-group__icon::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 37);
					}
				}
			}
			&[data-index='Лизинг недвижимости'] {
				.button-icon-group__icon {
					&::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 38);
					}
					// background-position-x: #{(81 * 0)}px;
				}
				&.active {
					.button-icon-group__icon::after {
						@include iconSprite('./../../../images/icon/round-outline-icon.svg', 65, 39);
					}
				}
			}
		}
		.button-icon-group__item.active {
			background-color: transparent;
			.button-icon-group__icon {
				background-color: #5c646f;
			}
		}
	}
	&__currency {
		display: flex;
		justify-content: flex-end;
		list-style: none;
		position: absolute;
		right: 0px;
		bottom: 5px;
		height: 20px;
		bottom: 66px;
	}
	&__currency_item {
		width: 20px;
		height: 20px;
		background-position: center;
		background-repeat: no-repeat;
		border-radius: 10px;
		background-image: url('./currency.svg');
		border: 2px solid transparent;
		cursor: pointer;

		&::before {
			content: '' !important;
		}
		&.active {
			border: 2px solid $brand-color;
		}
		&:hover {
			border: 2px solid $brand-color;
		}
		&#{&}--ruble {
			// @include background_icon('leasing-calculator__currency--ruble', 'svg');
			// background-image: ;
			background-position-x: -21px;
		}
		&#{&}--euro {
			// @include background_icon('leasing-calculator__currency--euro', 'svg');
			// background-image: ;
			background-position-x: -0px;
			background-position-x: -3px;
		}
		&#{&}--dollar {
			background-position-x: -42px;
		}
	}

	&__range {
		margin-bottom: 0px;
		position: relative;
		height: 94px;
		@media (max-width: 768px) {
			height: auto;
		}
		padding-top: 10px;
		.range-slider {
			margin: 0px 0px;
			margin-top: 3px;
		}
		& > label {
			font-weight: bold;
			font-size: 10px;
			line-height: 120%;
			/* identical to box height, or 17px */

			letter-spacing: 0.07em;
			text-transform: uppercase;

			color: #000000;
			margin-bottom: 10px;
			display: block;
		}
	}

	.btn {
		margin-top: 66px;
		@media (max-width: 768px) {
			margin-top: 40px;
			margin-bottom: 20px;
			width: 100%;
			font-size: 14px;
		}
		// cursor: pointer;
		// text-transform: uppercase;
		// border-radius: 5px;
		// width: 220px;
		// height: 50px;
		// margin-top: 8px;
		// margin-bottom: 160px;
	}
	&__images {
		position: absolute;
		right: 0px;
		bottom: 0px;
	}
	&__select {
		padding: 10px 20px;
		padding-right: 20px;
		width: 100%;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		font-size: 13px;
		&-wrap {
			position: relative;
		}
		&-arrow {
			position: absolute;
			right: 20px;
			top: 10px;
		}
	}
}
</style>
